import { initI18n } from '@nv/utils'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'

initI18n()

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App basename={'/'} />)
